import React, { createContext, ReactNode, useState } from 'react';
import { defaultColors } from 'utils/colors';

interface CustomStylesProviderProps {
  children: ReactNode;
}

interface StylesProps {
  file: string;
  brandName: string;
  name: string;
  backgroundColor: string;
  primaryColor: string;
  hideLogo: boolean;
}

const initialValues = {
  styles: {
    file: '',
    brandName: '',
    name: '',
    backgroundColor: defaultColors?.length > 0 ? defaultColors[0] : '',
    primaryColor: defaultColors?.length > 1 ? defaultColors[1] : '',
    hideLogo: false,
  },
  setStyles: () => null,
};

interface ContextProps {
  styles: StylesProps;
  setStyles: (value: StylesProps) => void;
}

export const CustomStyles = createContext<ContextProps>(initialValues);

export function CustomStylesProvider({ children }: CustomStylesProviderProps) {
  const [styles, setStyles] = useState<StylesProps>(initialValues.styles);

  return <CustomStyles.Provider value={{ styles, setStyles }}>{children}</CustomStyles.Provider>;
}

export const useCustomStyles = () => React.useContext(CustomStyles);
